module.exports = __webpack_public_path__ + "static/outProductsCasting.3ba81697.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/section-our-products/images/outProductsCasting.jpg
// module id = 645
// module chunks = 132207355946902